import CommonIcon from './common-icon.vue';
export {CommonIcon};


// WEBPACK FOOTER //
// ./src/components/icon/index.js